/**
 * Declaring object for the default blue color
 */
const rapidBackgroundDark = {
	paper: '#17171a',
	default: '#0c0c0d',
};

export default rapidBackgroundDark;
